import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const moduleRole = {
  namespaced: true,

  state: {
    name: 'roles',
    roles: [],
  },

  mutations,
  getters,
  actions
}

export default moduleRole;